module.exports = __webpack_public_path__ + "img/2022-02.ce427014.jpg";